import { node_observable_component } from 'common/util/ComponentDecorator';
import PluralUtil from 'common/util/PluralUtil';

@node_observable_component
export default class pointsDp {
	static classname = 'points-dp';

	_filters = [];
	_service_id;
	_search_query = '';
	_is_no_points = false;
	_points_count_all;
	_points_counts = {};

	_backup = {};

	_is_points_instance_init = false;

	constructor($context) {
		this.$context = $context;

		this.bindEvents();
		this.bindGlobalEvents();

		this._service_id = this.$context.data('service-id');
		this._points_count_all = +this.$context.data('points-count-all');
		this._points_counts = this.$context.data('points-counts');
		if (this._points_counts instanceof Array) {
			this._points_counts = {};
		}
		this._backup._points_count_all = this._points_count_all;
		this._backup._points_counts = { ...this._points_counts };

		this.init();
	}

	get id() {
		return this.$context.data('id');
	}

	get PointsInstance() {
		if (window.shop_dp && window.shop_dp.loader && window.shop_dp.loader.assets) {
			const { shop_dp: { loader: { assets } } } = window;

			let services = {};
			if (assets.page && assets.page.services) {
				services = assets.page.services;
			} else if(assets.product && assets.product.services) {
				services = assets.product.services;
			}

			if (services.points) {
				return services.points;
			} else if (services[this.id]) {
				return services[this.id];
			}
		}

		return null;
	}

	get filters() {
		return this._filters;
	}

	set filters(filters) {
		this._filters = filters;

		this.handleChangeFilters();
	}

	get view_type() {
		if (this.$context.hasClass('points-dp_map')) {
			return 'map';
		} else {
			return 'list';
		}
	}

	set view_type(view_type) {
		this.$context.attr('class', `points-dp points-dp_${view_type} points-dp_service-${this.service_id === 'all' ? 'all' : 'specific'}`);

		this.handleChangeViewType();
	}

	get filters_visibility() {
		return this.$context.hasClass('points-dp_filters-visible');
	}

	set filters_visibility(filters_visibility) {
		this.$context.toggleClass('points-dp_filters-visible', filters_visibility);
	}

	get service_id() {
		return this._service_id;
	}

	set service_id(service_id) {
		this._service_id = service_id;
		this.$context.attr('data-service-id', this._service_id);
		this.$context.toggleClass('points-dp_service-all', this._service_id === 'all');
		this.$context.toggleClass('points-dp_service-specific', this._service_id !== 'all');

		this.handleSwitchService();
	}

	get search_query() {
		return this._search_query;
	}

	set search_query(search_query) {
		this._search_query = search_query;

		this.handleChangeSearchQuery();
	}

	get is_no_points() {
		return this._is_no_points;
	}

	set is_no_points(is_no_points) {
		this._is_no_points = is_no_points;

		this.$context.toggleClass('points-dp_no-points', this._is_no_points);
	}

	get points_counts() {
		return this._points_counts;
	}

	set points_counts(points_counts) {
		this._points_counts = points_counts;
		this.handleChangePointsCounts();
	}

	get points_count_all() {
		return this._points_count_all;
	}

	set points_count_all(points_count_all) {
		this._points_count_all = points_count_all;
		this.handleChangePointsCountAll();
	}

	init() {
		if (!this.points_counts[this._service_id]) {
			this.setService('all');
		} else {
			this.setService(this._service_id);
		}
	}

	bindEvents() {
		const self = this;

		this.$context.find('.points-dp__filter-checkbox').on('change', function () {
			const $filter = $(this);
			const filter_id = $filter.data('filter-id');
			const status = $filter.is(':checked');

			self.setFilter(filter_id, status);
		});

		this.$context.find('.points-dp__view-option').on('click', function () {
			const view_type = $(this).data('view-type');
			self.view_type = view_type;
		});

		this.$context.find('.points-dp__filter-toggler').on('click', function () {
			self.filters_visibility = !self.filters_visibility;
		});

		this.$context.find('.points-dp__service-switcher-select-field').on('change', function () {
			const service_id = $(this).val();
			self.setService(service_id, true, false);
		});

		this.$context.find('.points-dp__service-switcher-item').on('click', function () {
			const service_id = $(this).data('value');
			self.setService(service_id);
		});

		this.$context.find('.points-dp__search-field').on('input', function () {
			self.search_query = $(this).val();
		});
	}

	bindGlobalEvents() {
		$(document).on('click', e => {
			const $target = $(e.target);
			if ($target.closest(this.$context.find('.points-dp__filters')).length === 0 && $target.closest(this.$context.find('.points-dp__filter-toggler')).length === 0) {
				this.filters_visibility = false;
			}
		});

		$(document).on('shop-dp-points-inited', this.handlePointsInstanceInit);

		$(document).on('shop-dp-points-before-set-service', this.handlePointsInstanceBeforeServiceChanged);

		$(window).on('resize', this.handleWindowResize);
	}

	setFilter(filter_id, status) {
		if (!status) {
			this.filters = this.filters.filter(_filter_id => _filter_id !== filter_id);
		} else {
			if (!this.filters.includes(filter_id)) {
				this.filters = [
					...this.filters,
					filter_id
				];
			} else {
				this.filters = this.filters;
			}
		}
	}

	setService(id, update_item = true, update_select = true) {
		if (update_item) {
			this.setServiceSwitcherItem(id);
		}
		if (update_select) {
			this.setServiceSwitcherSelect(id);
		}

		this.service_id = id;
	}

	setServiceSwitcherItem(value) {
		this.$context.find('.points-dp__service-switcher-item').each(function () {
			$(this).toggleClass('points-dp__service-switcher-item_selected', $(this).data('value') === value);
		});
	}

	setServiceSwitcherSelect(value) {
		const $select = this.$context.find('.points-dp__service-switcher-select-field');
		if ($select.length) {
			$select.val(value).trigger('refresh');
		}
	}

	resetFilter() {
		const $points = this.$context.find('.points-dp-point');
		$points.removeClass('points-dp-point_hidden');

		this.points_counts = this._backup._points_counts;
		this.points_count_all = this._backup._points_count_all;

		this.handleAfterFilter();
	}

	triggerResetFilter() {
		this.$context.find('.points-dp__filter-checkbox').prop('checked', false).trigger('change');
		this.$context.find('.points-dp__search-field').val('').trigger('input');
	}

	filter() {
		const self = this;

		const $points = this.$context.find('.points-dp-point');

		const is_search = this.filters.includes('search');
		let search_regexp;
		if (is_search) {
			search_regexp = new RegExp(`(${this.search_query})`, 'i');
		}
		const filters = this.filters.filter(filter_id => filter_id !== 'search');

		let points_count_all = 0;
		let points_counts = {};

		$points.each(function () {
			const $point = $(this);
			const name = $point.data('name');
			const address = $point.data('address');
			const service_id = $point.data('service-id');

			let result = true;
			let search_result = false;

			if (is_search) {
				search_result = search_regexp.test(name) || search_regexp.test(address);
				result = result && search_result;
			}

			self.highlight$Point($point, search_regexp, search_result);

			filters.forEach(filter_id => {
				let field = +$point.data(filter_id) || 0;

				result = result && field === 1;
			});

			$point.toggleClass('points-dp-point_hidden', !result);

			if (!points_counts.hasOwnProperty(service_id)) {
				points_counts[service_id] = 0;
			}

			if (result) {
				points_count_all++;
				points_counts[service_id]++;
			}
		});

		this.points_counts = points_counts;
		this.points_count_all = points_count_all;

		this.handleAfterFilter();
	}

	highlight$Point($point, regexp, status) {
		const $name = $point.find('.points-dp-point__name');
		const $address = $point.find('.points-dp-point__address');
		const name = $name.data('default') || '';
		$name.html(name);
		const address = $address.data('default') || '';
		$address.html(address);

		if (!status) {
			return;
		}

		const name_highlighted = name.replace(regexp, '<span class="points-dp-point__highlight">$1</span>');
		const address_highlighted = address.replace(regexp, '<span class="points-dp-point__highlight">$1</span>');
		$name.html(name_highlighted);
		$address.html(address_highlighted);
	}

	updateCounter(service_id, count) {
		const $select = this.$context.find('.points-dp__service-switcher-select-field');
		if ($select.length) {
			const $option = $select.find(`option[value="${service_id}"]`);
			if ($option.length) {
				const $label = $('<div/>').html($option.data('label'));
				$label.find('.points-dp__service-switcher-select-counter').html(count);
				const label = $label.html();
				$option.attr('data-label', label).data('label', label);

				$option.toggle(!!count);

				$select.trigger('refresh');
			}
		}

		const $item = this.$context.find(`.points-dp__service-switcher-item[data-value="${service_id}"]`);
		if ($item.length) {
			const $counter = $item.find('.points-dp__service-switcher-item-counter');
			if ($counter.length) {
				$counter.html(count);
			}

			$item.toggle(!!count);
		}

		if (service_id === 'all') {
			const $title = this.$context.find('.points-dp__service-switcher-title');
			const plural_forms = $title.data('plural-forms');

			$title.html(`${count} ${PluralUtil(count, plural_forms)}:`);
		}
	}

	prepareBalloonPanel() {
		if (this.PointsInstance) {
			this.PointsInstance.map.map.options.set('balloonPanelMaxHeightRatio', 1);
			this.PointsInstance.map.map.options.set('balloonPanelMaxMapArea', ResponsiveUtil.isToTablet() ? Infinity : 0);
		}
	}

	triggerDpFilter() {
		const $trigger = $('.points-dp__trigger_filter');
		$trigger.find(':checkbox').prop('checked', false);

		if (this.filters.includes('cashless')) {
			$trigger.find('[data-filter-by="cashless"]').prop('checked', true);
		}

		if (this.filters.includes('weekends')) {
			$trigger.find('[data-filter-by="working-sat"]').prop('checked', true);
			$trigger.find('[data-filter-by="working-sun"]').prop('checked', true);
		}

		const $service_switcher = $trigger.find('.js-dp-service-switcher');
		$service_switcher.attr('data-service', this.service_id);
		$service_switcher.data('service', this.service_id);

		$trigger.find(':checkbox:first').trigger('change');

		const $search_trigger = this.$context.find('.js-dp-service-search-field');
		$search_trigger.trigger('change');

		if (this.PointsInstance) {
			this.PointsInstance.togglePointsWithSearch();
			this.PointsInstance.updateClusterers();
		}
	}

	handleChangeFilters = () => {
		this.triggerDpFilter();

		if (this.filters.length === 0) {
			this.resetFilter();
		} else {
			this.filter();
		}
	};

	handleAfterFilter = () => {
		const $groups = this.$context.find('.points-dp__list-group');

		$groups.each(function () {
			const $group = $(this);
			const group = $group[0];
			const count_total = group.querySelectorAll('.points-dp-point').length;
			const count_hidden = group.querySelectorAll('.points-dp-point_hidden').length;

			$group.toggleClass('points-dp__list-group_no-points', count_total === count_hidden);
		});

		const groups_count_total = $groups.length;
		const groups_count_no_points = this.$context.find('.points-dp__list-group_no-points').length;

		this.is_no_points = groups_count_total === groups_count_no_points;
	};

	handleChangeViewType = () => {
		if (this.view_type === 'map') {
			if (this.PointsInstance) {
				this.PointsInstance.map.centerDefault();
			}
		}
	};

	handleSwitchService = () => {
		const self = this;

		this.$context.find('.points-dp__list-group').each(function() {
			const $group = $(this);
			const service_id = $group.data('service-id');

			$group.toggleClass('points-dp__list-group_hidden', !(self.service_id === 'all' || self.service_id === service_id));
		});

		if (this.PointsInstance && this._is_points_instance_init) {
			this.PointsInstance.setService(0, {
				code: this.service_id,
				manual: true
			}, () => {
				this.triggerDpFilter();
			});
		}
	};

	handleChangeSearchQuery = () => {
		this.$context.find('.js-dp-service-search-field').val(this.search_query);
		this.setFilter('search', this.search_query !== '');
	};

	handleChangePointsCountAll = () => {
		this.updateCounter('all', this.points_count_all);
	};

	handleChangePointsCounts = () => {
		Object.entries(this.points_counts).forEach(([service_id, count]) => this.updateCounter(service_id, count))
	};

	handlePointsInstanceInit = () => {
		this._is_points_instance_init = true;

		if (!this.points_counts[this.service_id] || this.points_counts[this.service_id] == 0) {
			this.setService('all');
		}

		this.prepareBalloonPanel();
	};

	handlePointsInstanceBeforeServiceChanged = (e, id, params) => {
		if (!params || !params.code || params.manual) {
			return;
		}

		const { code: service_id } = params;
		this.setService(service_id);
		this.triggerResetFilter();
	};

	handleWindowResize = () => {
		this.prepareBalloonPanel();
	};
}
